import client from './client';

export async function login(email, password) {
  const response = await client.post('/login', { email, password });
  return response.data;
}

export async function register(data) {
  const response = await client.post('/register', data);
  return response.data;
}

export async function logout() {
  const response = await client.post('/logout');
  return response.data;
}

export async function getMe() {
  const response = await client.get('/me');
  return response.data;
}
